<template>
  <div id="app" class="container">
    <br />
    <br />

    <div>
      <div class="row">
        <div class="col-xs-12 text-left" style="margin-top:30px;">
          <div v-if="projectLogo" class="text-right" style="float: left !important;">
            <img :src="projectLogo" class="resize-project-logo-lg" />
          </div>
          <div
            style="float: left; font-size: 12px; font-family: Times New Roman, Times, serif;"
          >
            <span>{{ receipt_data.operator_name }}</span>
            <br /><span>{{ receipt_data.operator_address }}</span>
            <br />MST: {{ receipt_data.tax_identification_number }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-center"
      style="background-color:#168AD6;font-size: 20px; font-family: Times New Roman, Times, serif; 
      font-weight: bold; text-transform: uppercase;margin-top:15px;color:white;"
    >
      <span v-if="!receipt_data.used_wallet">PHIẾU THU</span>
      <div v-else>
        <span style="display: block;">PHIẾU THANH TOÁN</span>
        <span>(SỬ DỤNG SỐ DƯ)</span>
      </div>
    </div>
    <div
      class="text-center"
      style="font-size: 16px; font-family: Times New Roman, Times, serif; text-transform: uppercase;"
      v-if="!receipt_data.used_wallet"
    >
      <i>RECEIPT</i>
    </div>
    <div style="margin-top:20px;">
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif;border:1px solid white;text-align:center;width:61%;"
      ></div>
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif; border:1px solid white;text-align:center;"
      >
        <b>Số</b> / <i>No.</i>:
        <b>{{ receipt_data.receipt_code }}</b>
      </div>
    </div>

    <div></div>

    <div class="container" style="margin-top:30px;">
      <div class="row">
        <table
          class="table table-condensed"
          style="width:80%; border:0px solid red; margin-left : 10%"
        >
          <tbody>
            <tr>
              <td style="width:20%"><b>Ngày</b> / <i>Date</i>:</td>
              <td style="width:60%">
                <b class="text-uppercase" style="text-align:left;">{{
                  receipt_data.date_created
                }}</b>
              </td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Họ và tên người nộp tiền:</b>
                <br />
                <i>Name of Payment Applicant</i>
              </td>
              <td style="width:60%; text-transform: uppercase;">
                {{ receipt_data.resident_fullname }}
              </td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Địa chỉ:</b>
                <br />
                <i>Address</i>:
              </td>
              <td style="width:60%">{{ receipt_data.address }}</td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Số tiền / </b>
                <i>Total Amount</i>:
              </td>
              <td style="width:60%">
                {{
                  formatNumber(
                    receipt_data.payments_type != 3
                      ? receipt_data.amount
                      : receipt_data.amount_used_wallet
                  )
                }}
                (VNĐ)
              </td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Viết bằng chữ:</b>
                <br />
                <i>In Words</i>:
              </td>
              <td style="width:60%">
                <b>{{ readMoney(receipt_data.amount, "vi") }} ./.</b>
                <br />
                <i>({{ readMoney(receipt_data.amount, "en") }} ./.)</i>
              </td>
            </tr>
            <tr v-show="false">
              <td style="width:20%">
                <b>Nội dung:</b>
                <br />
                <i>Description</i>:
              </td>
              <td style="width:60%">
                <b
                  >Thanh toán dịch vụ sử dụng căn hộ
                  {{ receipt_data.apartment_code }}. Số tiền</b
                >
              </td>
            </tr>
            <tr v-show="true">
              <td style="width:20%">
                <b>Nội dung:</b>
                <br />
                <i>Description</i>:
              </td>
              <td style="width:60%">
                <b
                  >Thanh toán dịch vụ sử dụng căn hộ
                  {{ receipt_data.apartment_code }}. Số tiền
                  {{ formatNumber(receipt_data.amount) }}
                  VNĐ.
                  {{
                    receipt_data.expected_amount != receipt_data.amount ||
                    receipt_data.used_wallet
                      ? (!is_debt || receipt_data.used_wallet
                          ? "Số dư "
                          : "Dư nợ ") +
                        formatNumber(
                          receipt_data.used_wallet
                            ? surplus
                            : receipt_data.rest_of_amount
                        ) +
                        " VNĐ."
                      : "Số dư 0 VNĐ."
                  }}</b
                >
                <br />
                <i
                  >Payment for apartment services
                  {{ receipt_data.apartment_code }}. Amount:
                  {{ readMoney(receipt_data.amount, "en") }}. <br />
                  Excess: {{ readMoney(receipt_data.rest_of_amount, "en") }}.
                </i>
              </td>
            </tr>
          </tbody>
        </table>
        <div></div>
      </div>

      <div class="row">
        <table
          class="table table-condensed"
          style="border:0px; margin-left:5% "
        >
          <tr>
            <th class="text-center">
              <b>Người lập phiếu</b>
              <br />
              <i class="table_column_en">Drafted by</i>
            </th>
            <th v-if="!receipt_data.used_wallet" class="text-center">
              Người nộp tiền
              <br />
              <i class="table_column_en">Payment Applicant</i>
            </th>
            <th class="text-center">
              Thủ quỹ
              <br />
              <i class="table_column_en">Cashier</i>
            </th>
            <th class="text-center">
              Kế toán trưởng
              <br />
              <i class="table_column_en">Chief Accountant</i>
            </th>
            <th class="text-center">
              Thủ trưởng đơn vị
              <br />
              <i class="table_column_en">Director</i>
            </th>
          </tr>

          <br />
          <br />
          <br />

          <tr>
            <th class="text-center">
              {{ receipt_data.user_created_full_name }}
            </th>
            <th class="text-center"></th>
            <th class="text-center"></th>
            <th class="text-center"></th>
          </tr>
        </table>
      </div>
    </div>

    <br />
    <div class="row">
      <form class="form-horizontal">
        <div class>
          <button
            id="cmdCancel"
            type="button"
            class="btn btn-labeled btn-danger"
            @click="CancelInvoiceList"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label">
              <i class="fa fa-mail-reply"></i>
            </span>
            {{ $t("common.back") }}
          </button>
          <button
            id="cmdPrintPdf"
            type="button"
            class="btn btn-labeled btn-warning pull-right"
            @click="printInvoice"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.printPdf") }}
          </button>
        </div>
      </form>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Multiselect from "vue-multiselect";
// import LTEModal from "@/components/LTEModal.vue";
import utils from "@/lib/utils";
import ReceiptTypeEnum from "@/enum/receiptTypeEnum";
import i18n from "../../lang";
import siteImgConfig from '@/lib/siteImgConfig'
import buildConfig from "../../../build/config"

export default {
  name: "ReceiptPdf_TM",
  data() {
    return {
      projectLogo: null,
      ishow: false,
      receipt_data: {
        id: 0,
        receipt_code: "",
        expected_amount_show: 0,
        user_created: "",
        user_created_full_name: "",
        date_created: new Date(),
        excess_cash: 0,
        payments_type: 1,
        invoice_id: 0,
        monthy_services: [],
        receipt_monthy_services_name: "",
        resident_fullname: "",
        apartment_code: "",
        month: "",
        record_date: "",
        explaination: "",
        amount: 0,
        rest_of_amount: 0,
        current_day: null,
        current_month: null,
        current_year: null,
        surplus: 0,
        used_wallet: false,
        amount_used_wallet: 0,
        address: "",
        operator_name: "",
        operator_address: ""
      },
      is_debt: false,
      siteImgConfig: siteImgConfig
    };
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_RECEIPT_DETAIL"
    ]),
    formatNumber: function(amount) {
      return utils.formatNumber(amount);
    },
    readMoney: function(number, locale) {
      return utils.readMoney(number, locale);
    },
    CancelInvoiceList: function() {
      this.$router.push({
        name: "ReceiptList"
      });
    },

    onConfirm: function() {
      this.isModalVisible = false;
    },

    printInvoice: function() {
      document.getElementById("cmdCancel").style.display = "none";
      document.getElementById("cmdPrintPdf").style.display = "none";
      window.print();
      document.getElementById("cmdCancel").style.display = "";
      document.getElementById("cmdPrintPdf").style.display = "";
    },

    convertDateVN(date) {
      // Day
      let day = utils.formatSqlDate(date, null, "DD");
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return "Ngày " + day + " tháng " + month + " năm " + year;
    },
    convertDateMonth(date) {
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return " tháng " + month + " năm " + year;
    },
    convertDateEN(date) {
      return utils.formatSqlDate(date, null, "DD MMM YYYY");
    },

    formatTotalFee(total_fee, isFormat = false) {
      if (total_fee != undefined) {
        total_fee = utils.makeRoundNumber(total_fee);
        let rs = total_fee.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return rs == 0 && isFormat ? "-" : rs;
      }
    },
    getSiteInfo: function() {
      let results = null
      let index = this.siteImgConfig.findIndex(x=>x.site_name_info_value===buildConfig.SITE_NAME_INFO)
      if (index !== -1) {
        results = this.siteImgConfig[index]
      }
      return results
    },
    updateTabTitle: function() {
      var link = document.querySelector("link[rel*='shortcut icon']");
      let siteInfo = this.getSiteInfo()
      link.href = siteInfo.urlIcon
      document.title = siteInfo.site_name_info
    },
  },
  async mounted() {
    // Add or Update data
    let id = this.$route.params.id;
    let current_date = new Date();
    this.updateTabTitle()
    this.projectLogo = sessionStorage.getItem('projectLogo')
    this.receipt_data.current_day = current_date.getDate();
    this.receipt_data.current_month = current_date.getMonth() + 1;
    this.receipt_data.current_year = current_date.getFullYear();
    this.receipt_data.used_wallet = false;
    if (parseInt(id) !== 0) {
      let filter = {
        id: id
      };
      this.GET_RECEIPT_DETAIL(filter).then(
        function(res) {
          if (res.receipt_type == ReceiptTypeEnum.WALLET) {
            this.receipt_data.amount_used_wallet = res.amount;
          }
          // monthy_services
          this.receipt_data.id = res.id;
          this.receipt_data.receipt_code = res.receipt_code;

          this.receipt_data.user_created = res.user_created;
          this.receipt_data.user_created_full_name = utils.getFullName(
            res.user_first_name,
            res.user_last_name,
            i18n.locale
          );
          this.receipt_data.resident_fullname = utils.isNull(res.payer)
            ? res.apartment.owner_apartment
            : res.payer;
          this.receipt_data.date_created = utils.formatSqlDate(res.date_created, null, "DD/MM/YYYY");
          this.receipt_data.explaination = res.explaination;
          this.receipt_data.payments_type = res.receipt_type;
          this.receipt_data.invoice_id = res.invoice;
          this.receipt_data.apartment_code = res.apartment.apartment_code;
          this.receipt_data.month = utils.formatSqlDate(res.date_created, null, "MM");
          this.receipt_data.record_date = utils.formatSqlDate(res.due_date, null, "DD/MM/YYYY");
          this.receipt_data.address = !utils.isNull(
            res.apartment.apartment_code
          )
            ? res.apartment.apartment_code
            : "";
          this.receipt_data.operator_name = !utils.isNull(res.project_data.operator_name) ? res.project_data.operator_name : "";
          this.receipt_data.operator_address = !utils.isNull(res.project_data.operator_address) ? res.project_data.operator_address : "";
          this.receipt_data.tax_identification_number = !utils.isNull(res.project_data.tax_identification_number) ? res.project_data.tax_identification_number : "";
          this.receipt_data.amount = !utils.isNull(res.amount) ? res.amount : 0
          let balance = !utils.isNull(res.balance) ? res.balance : 0
          // số dư nhập từ file excel 
          // nên: âm dư tiền , dương là nợ tiền
          if (balance > 0) {
            this.is_debt = true
          } else {
            this.is_debt = false
          }
          this.receipt_data.rest_of_amount = Math.abs(balance)
          // this.receipt_data.rest_of_amount = balance

        }.bind(this)
      );

      await utils.sleep(1000);
    } else {
      // ERROR
    }
  },
  components: {}
};
</script>

<style scoped>
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}

.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}

.btn {
  margin-bottom: 10px;
}

.table_total_fee {
  border: 2px solid #000000;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
  border: 2px solid #000000;
}

.container {
  font-family: Times New Roman, Times, serif !important;
}

body {
  font-size: 12px !important;
}
.resize-project-logo-lg {
  height: auto;
  width: auto;
  max-width: 80px;
  max-height: 60px;
}
@media print {
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
/* remove title when print */
@page {
  size: auto;
  margin: 0mm;
}

.table_column_en {
  font-style: italic;
  font-weight: 100;
}

table {
  border: 1px solid #ccc;
  border-collapse: collapse;
}

td {
  border-top: 0px solid !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Receipt/ReceiptPdf_TMV2.vue